const setStateAsync = (component, state) => new Promise ((resolve, reject) => {
  component.setState(state, () => {
    resolve();
  })
})
export default setStateAsync
